export const BROWSE_LINK_LIST = [{
  'title': 'Art & Mirrors',
  'values': ['bathroom-mirrors',
    'art-prints',
    'metal-wall-art',
    'large-wall-art',
    'canvas-wall-art',
    'wall-mirrors',
    'poster-prints',
    'vanity-mirrors',
    'framed-prints',
    'decorative-mirrors',
    'fine-art-prints',
    'big-wall-art',
    'floor-mirrors',
    'oversized-wall-art',
    'full-length-mirrors',
    'large-canvas-art',
    'extra-large-wall-art',
    'large-mirrors',
    'acrylic-wall-art',
    'western-wall-art',
    'modern-mirrors',
    'contemporary-wall-art',
    'woven-wall-art',
    'giant-wall-art',
    'huge-wall-art',
    'arched-mirrors',
    'vinyl-wall-art',
    'oversized-mirrors',
    'standing-mirrors',
    'botanical-art-prints',
    'rustic-mirrors',
    'framed-botanical-prints',
    'coastal-mirrors',
    'white-mirrors'],
},
{
  'title': 'Bedroom Furniture',
  'values': ['bedroom-sets',
    'white-dresser',
    'murphy-beds',
    'queen-headboard',
    'king-headboard',
    'bedroom-dresser',
    'bedroom-furniture-sets',
    'black-nightstand',
    'floating-nightstand',
    'modern-dresser',
    'king-size-bedroom-sets',
    'small-nightstand',
    'nursery-dresser',
    'white-bedroom-set',
    'full-size-bedroom-sets',
    'mirrored-dresser',
    'modern-bedroom-furniture',
    'tall-nightstand',
    'modern-platform-bed',
    'california-king-bedroom-sets',
    'mirrored-nightstand',
    'mid-century-modern-bedroom-set',
    'charging-nightstand',
    'contemporary-bedroom-furniture',
    'luxury-bedroom-furniture',
    'white-queen-bedroom-set',
    'white-king-bedroom-set',
    'king-size-bedroom-suite',
    'modern-upholstered-bed',
    'black-queen-bedroom-set',
    'king-size-headboard-with-storage',
    'modern-storage-bed',
    'scandinavian-bedroom-furniture'],
},
{
  'title': 'Decor',
  'values': ['wall-murals',
    'desk-accessories',
    'boho-throw-pillows',
    'lumbar-pillows',
    'desk-plants',
    'desk-organizers',
    'decorative-throw-pillows',
    'velvet-pillows',
    'desk-risers',
    'bolster-pillows',
    'floral-throw-pillows',
    'velvet-throw-pillows',
    'ceramic-garden-stool',
    'designer-throw-pillows',
    'round-throw-pillows',
    'farmhouse-throw-pillows',
    'luxury-throw-pillows',
    'personalized-throw-pillows',
    'luxury-desk-accessories'],
},
{
  'title': 'Dining Room Furniture',
  'values': ['bar-stools',
    'bar-cart',
    'dining-room-sets',
    'dining-chairs',
    'round-dining-table',
    'counter-stools',
    'extendable-dining-table',
    'counter-height-bar-stools',
    'small-kitchen-table',
    'oval-dining-table',
    'modern-dining-table',
    'dining-set',
    'farmhouse-dining-table',
    'kitchen-tables',
    'marble-dining-table',
    'dining-tables',
    'drop-leaf-table',
    'upholstered-dining-chairs',
    'glass-dining-table',
    'solid-wood-dining-table',
    'counter-height-dining-set',
    'white-dining-table',
    'rattan-dining-chairs',
    'square-dining-table',
    'leather-dining-chairs',
    'kitchen-bar-stools',
    'expandable-dining-table',
    'gold-bar-cart',
    'leather-bar-stools',
    'bar-furniture',
    'counter-height-dining-table',
    'marble-top-dining-table',
    'drop-leaf-dining-table',
    'round-pedestal-dining-table',
    'breakfast-nook-dining-set',
    'farmhouse-dining-set',
    'metal-dining-chairs',
    'swivel-counter-stools',
    'white-oak-dining-table',
    'home-bar-furniture',
    'wicker-dining-chairs',
    'bar-height-dining-table',
    'adjustable-bar-stools',
    'expandable-table',
    'glass-top-dining-table',
    'leather-counter-stools',
    'counter-height-stools-with-backs',
    'home-bar-cabinet',
    'backless-bar-stools',
    'marble-dining-table-set',
    'trestle-dining-table',
    'space-saving-dining-table',
    'mini-bar-cart',
    'pub-tables',
    'faux-leather-dining-chairs',
    'backless-counter-stools',
    'solid-oak-dining-table',
    'windsor-dining-chairs',
    'butterfly-leaf-dining-table',
    'breakfast-nook-set',
    'faux-marble-dining-table',
    'counter-height-kitchen-table',
    'farmhouse-dining-room-table',
    'round-pedestal-table',
    'wine-bar-cabinet',
    'luxury-dining-table',
    'grey-dining-table',
    '6-piece-dining-set',
    'bistro-sets',
    'wood-bar-cart',
    'marble-round-dining-table',
    'convertible-dining-table',
    'bar-sets',
    'drop-leaf-kitchen-table',
    'upholstered-counter-stools',
    '8-piece-dining-set',
    'breakfast-bar-stools',
    'marble-dining-room-table',
    'extendable-dining-room-table',
    'wooden-counter-stools',
    'bamboo-dining-chairs',
    'rattan-dining-table',
    'custom-dining-table',
    'extension-table',
    'breakfast-nook-tables',
    'ladder-back-dining-chairs',
    'parsons-dining-chairs',
    'foldable-kitchen-table',
    'farmhouse-kitchen-chairs',
    'expanding-dining-table',
    'commercial-bar-furniture',
    'seagrass-dining-chairs',
    'industrial-bar-cart'],
},
{
  'title': 'Entryway Furniture',
  'values': ['entryway-furniture',
    'entryway-tables',
    'foyer-tables',
    'entryway-mirrors'],
},
{
  'title': 'Furniture',
  'values': ['modern-furniture',
    'scandinavian-furniture',
    'rustic-furniture',
    'leather-furniture',
    'contemporary-furniture',
    'coastal-furniture',
    'farmhouse-furniture',
    'mission-style-furniture',
    'clearance-furniture',
    'space-saving-furniture',
    'custom-furniture',
    'designer-furniture',
    'retro-furniture',
    'apartment-size-furniture'],
},
{
  'title': 'Lighting',
  'values': ['floor-lamps',
    'table-lamps',
    'desk-lamps',
    'table-lamps-for-living-room',
    'modern-floor-lamps',
    'floor-lamp-with-table',
    'bedside-table-lamps',
    'brass-floor-lamp',
    'modern-wall-sconces',
    'island-lighting',
    'path-lights',
    'living-room-table-lamps',
    'bedroom-wall-sconces',
    'bathroom-chandeliers',
    'flush-mount-ceiling-lights',
    'vintage-floor-lamps',
    'drum-chandelier',
    'bathroom-wall-sconces',
    'antique-floor-lamps',
    'visual-comfort-sconces',
    'lantern-pendant-light',
    'farmhouse-table-lamps',
    'ceramic-table-lamps',
    'mid-century-modern-table-lamps',
    'glass-table-lamps',
    'tall-floor-lamps',
    'rustic-table-lamps',
    'vintage-pendant-lighting',
    'tiffany-floor-lamps',
    'hallway-ceiling-lights',
    'contemporary-chandeliers',
    'tiffany-table-lamps',
    'coastal-light-fixtures',
    'contemporary-table-lamps',
    'crystal-pendant-lighting',
    'plug-in-wall-sconces',
    'kitchen-island-chandelier',
    'crystal-table-lamps',
    'ceiling-fan-light-kits',
    'coastal-table-lamps',
    'arc-floor-lamps',
    'kitchen-chandeliers',
    'coastal-floor-lamps',
    'black-chandeliers',
    'tiffany-style-table-lamps',
    'brass-table-lamps',
    'chandelier-light-fixtures',
    'rustic-floor-lamps',
    'drum-pendant-lighting',
    'led-floor-lamps',
    'rustic-ceiling-lights',
    'farmhouse-pendant-lighting',
    'art-deco-table-lamps',
    'reading-floor-lamps',
    'vintage-chandeliers',
    'mid-century-modern-wall-sconces',
    'motion-sensor-lighting',
    'glass-pendant-lighting',
    'brass-chandeliers',
    'black-floor-lamps',
    'brass-floor-lamps',
    'drum-shade-chandelier',
    'buffet-table-lamps',
    'tripod-floor-lamps',
    'gold-chandeliers',
    'post-light-fixtures',
    'black-table-lamps',
    'battery-powered-light-fixtures',
    'contemporary-floor-lamps',
    'gold-floor-lamps',
    'mini-pendant-lighting',
    'traditional-table-lamps',
    'black-wall-sconces',
    'wood-table-lamps',
    'semi-flush-mount-ceiling-lights',
    'farmhouse-floor-lamps',
    'wooden-floor-lamps',
    'home-lighting-fixtures',
    'white-floor-lamps',
    'wood-chandeliers',
    'contemporary-wall-sconces',
    'usb-table-lamps'],
},
{
  'title': 'Living Room Furniture',
  'values': ['accent-chairs',
    'tv-stands',
    'sectional-couches',
    'sectional-sofas',
    'recliners',
    'coffee-tables',
    'living-room-sets',
    'lift-top-coffee-table',
    'futons',
    'marble-coffee-table',
    'sofa-beds',
    'square-coffee-table',
    'massage-chairs',
    'small-coffee-table',
    'console-tables',
    'recliner-chairs',
    'swivel-accent-chair',
    'sleeper-sofas',
    'narrow-side-table',
    'loveseats',
    'sofa-tables',
    'entertainment-centers',
    'large-coffee-table',
    'living-room-end-tables',
    'leather-accent-chair',
    'c-shaped-side-table',
    'coffee-table-sets',
    'leather-sofas',
    'sofa-sets',
    'sofa-side-table',
    'reclining-sofas',
    'velvet-accent-chair',
    'industrial-coffee-table',
    'power-lift-chairs',
    'oversized-chairs',
    'small-sofas',
    'round-accent-table',
    'sleeper-couches',
    'reclining-couches',
    'recliners-for-tall-people',
    'nesting-end-tables',
    'chairside-table',
    'luxury-sofas',
    'fabric-sofas',
    'narrow-end-tables',
    'leather-club-chairs',
    'couch-and-loveseat-sets',
    'oversized-couches',
    'chesterfield-sofas',
    'futon-frames',
    'leather-sofa-sets',
    'modern-sofa-sets',
    'metal-end-tables',
    'mid-century-modern-couches',
    'reclining-sofa-sets',
    'clearance-sofas',
    'club-chair-with-ottoman',
    'corner-accent-table',
    'oversized-sofas',
    'living-room-sofa-sets',
    'convertible-couches',
    'industrial-side-table',
    'sectional-sofas-for-small-spaces',
    'wingback-accent-chair'],
},
{
  'title': 'Office Furniture',
  'values': ['office-chairs',
    'office-furniture',
    'desk-chairs',
    'bookcases',
    'office-desks',
    'home-office-furniture',
    'home-office-desks',
    'modern-office-furniture',
    'home-office-chairs',
    'office-desk-furniture',
    'executive-desks',
    'office-desk-chairs',
    'executive-office-furniture',
    'modern-office-chairs',
    'desk-furniture',
    'office-workstations',
    'modern-office-desks',
    'white-office-furniture',
    'office-sets',
    'luxury-office-furniture',
    'home-office-sets',
    'office-bookcases',
    'white-office-chairs'],
},
{
  'title': 'Outdoor',
  'values': ['patio-furniture',
    'outdoor-rugs',
    'outdoor-patio-furniture',
    'patio-chairs',
    'outdoor-cushions',
    'outdoor-string-lights',
    'outdoor-pillows',
    'outdoor-chair-cushions',
    'patio-cushions',
    'rattan-furniture',
    'outdoor-lounge-chairs',
    'outdoor-planters',
    'patio-furniture-covers',
    'deck-furniture',
    'patio-umbrellas',
    'patio-dining-sets',
    'patio-sets',
    'outdoor-bar-stools',
    'indoor-outdoor-rugs',
    'outdoor-dining-chairs',
    'outdoor-wall-decor',
    'outdoor-fountains',
    'outdoor-dining-sets',
    'outdoor-cushion-covers',
    'porch-swings',
    'outdoor-folding-chairs',
    'outdoor-patio-rugs',
    'outdoor-chandelier',
    'patio-rugs',
    'outdoor-benches',
    'outdoor-wall-art',
    'outdoor-throw-pillows',
    'garden-stool',
    'patio-curtains',
    'patio-tables',
    'outdoor-bar-cart',
    'outdoor-rocking-chairs',
    'outdoor-patio-cushions',
    'outdoor-dining-furniture',
    'outdoor-mats',
    'patio-conversation-sets',
    'outdoor-door-mats',
    'patio-lounge-chairs',
    'outdoor-post-lights',
    'outdoor-conversation-sets',
    'outdoor-lounge-furniture',
    'outdoor-side-tables',
    'outdoor-lamps',
    'patio-rocking-chairs',
    'porch-rocking-chairs',
    'patio-dining-chairs',
    'outdoor-lumbar-pillows',
    'outdoor-plant-stands',
    'outdoor-bench-cushions',
    'sunbrella-outdoor-pillows',
    'outdoor-statues',
    'outdoor-pendant-lighting',
    'patio-pillows',
    'outdoor-sofa-cushions',
    'outdoor-swing-sets',
    'outdoor-sectional-furniture',
    'patio-swings',
    'glider-chairs',
    'outdoor-gazebos',
    'outdoor-sofas',
    'outdoor-flags',
    'outdoor-ottomans',
    'outdoor-dining-sets-for-8',
    'outdoor-coffee-tables',
    'patio-side-tables',
    'outdoor-bar-furniture',
    'outdoor-flush-mount-light',
    'outdoor-recliners',
    'deck-umbrellas',
    'patio-gazebos',
    'outdoor-patio-bar',
    'patio-end-tables',
    'outdoor-daybeds',
    'outdoor-patio-dining-sets',
    'outdoor-chaise-lounges',
    'patio-dining-tables',
    'outdoor-gliders',
    'outdoor-bean-bags',
    'patio-sectionals',
    'outdoor-wall-light-fixtures',
    'outdoor-loveseats',
    'outdoor-chandeliers',
    'outdoor-bar-sets',
    'outdoor-metal-art',
    'outdoor-chaise-cushions',
    'outdoor-lounge-cushions',
    'outdoor-poufs',
    'outdoor-bistro-sets',
    'patio-gliders',
    'outdoor-picnic-tables',
    'outdoor-tablecloths',
    'deck-rugs',
    'outdoor-deep-seat-cushions',
    'outdoor-sculptures',
    'conversation-sets',
    'jute-outdoor-rug',
    'brass-outdoor-lighting',
    'patio-lamp',
    'patio-bistro-sets',
    'patio-coffee-tables',
    'coastal-outdoor-lighting',
    'large-outdoor-light-fixtures'],
},
{
  'title': 'Rugs',
  'values': ['door-mats',
    'entryway-rugs',
    'blue-area-rugs',
    'personalized-door-mat',
    'contemporary-area-rugs',
    'handmade-persian-rugs',
    'monogrammed-door-mat'],
},
{
  'title': 'Tabletop & Bar',
  'values': ['best-dinnerware-sets',
    'stoneware-dinnerware-sets',
    'ceramic-dinnerware-sets',
    'square-dinnerware-sets',
    'glass-dinnerware-set',
    'vintage-dinnerware-sets',
    'chip-resistant-dinnerware',
    'lead-free-dinnerware',
    'unique-dinnerware-sets'],
}] as const
